import { Button, Card, Grid2, TextField, Typography } from "@mui/material";
import TagSelect from "components/global/TagSelect";
import { actions as globalAppActions } from "components/global/logic/actions";
import { Field, Form, Formik } from "formik";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { connect } from "react-redux";
import { API_URL } from "services";
import ConfirmDialog from "../../common/ConfirmDialog";
import { actions } from "../logic/actions";

import TextAreaEditor from "components/common/TextAreaEditor";
import ReviewStatusTypesSelect from "components/global/ReviewStatusTypesSelect";
import "./styles.scss";

import Autocomplete from "@mui/material/Autocomplete";
import UserSelect from "components/global/UserSelect";
import CreatableSelect from 'react-select/creatable';
import { REVIEW_TIME } from "../../../core/dataConstants";

const AddReviewForm = forwardRef((props, ref) => {
    const {
        outlined,

        onChange,
        onSubmit,
        onReset,
        review,
        tags,
        instructionPreset,
        getInstructionPreset,
    } = props;

    const [openDialog, setOpenDialog] = useState(false);
    const [invalidReviewTime, setInvalidReviewTime] = useState(false);
    const instructionPresetOptions = instructionPreset.map((instruction) => {
        return {
            label: instruction.name,
            value: instruction.instructionValue,
        };
    });

    useEffect(() => {
        getInstructionPreset(API_URL.instructionPreset());
    }, [getInstructionPreset]);

    useEffect(() => {
        if (review === null) {
            instructionRef.current.setValue("");
            privateNoteRef.current.setValue("");
        }
    }, [review]);

    const bagRef = useRef();
    const privateNoteRef = useRef();
    const instructionRef = useRef();

    useImperativeHandle(ref, () => ({
        getValues() {
            return {
                ...bagRef.current.values,
                privateNote: privateNoteRef.current.getValue(),
                instruction: instructionRef.current.getValue(),
            };
        },
        isDirty() {
            return bagRef.current.dirty;
        },
    }));

    let defaultTagIds =
        review &&
        review.tagIds.map((v) => {
            if (typeof v !== "object") {
                return {
                    value: v,
                    label: tags.find((t) => t.id === v).value,
                };
            }
            return v;
        });

    function handleSubmit(values, formikBag) {
        const textArea = {
            privateNote: privateNoteRef.current.getValue(),
            instruction: instructionRef.current.getValue(),
        };
        if (onSubmit) {
            onSubmit({ ...values, dateEntered: new Date(), ...textArea }, formikBag);
        } else {
            formikBag.setSubmitting(false);
            formikBag.resetForm();
        }
    }

    function handleCloseClearConfirm() {
        setOpenDialog(false);
    }

    function handleConfirmClear(resetForm) {
        instructionRef.current.setValue("");
        privateNoteRef.current.setValue("");
        onReset();
        resetForm();
        setOpenDialog(false);
    }

    function handleReviewTimeChange(value, setFieldValue) {
        if (isNaN(Number(value))) {
            setInvalidReviewTime(true);
        }
        else {
            setInvalidReviewTime(false);
            setFieldValue("reviewMinutes", Number(value));
        }
    }

    const reviewTimeOptions = () => {
        if (review && review.reviewMinutes) {
            if(REVIEW_TIME.findIndex(time => time.value === review.reviewMinutes) === -1) {
                return REVIEW_TIME.concat([{label: `${review.reviewMinutes}`, value: review.reviewMinutes}]);
            }
            else return REVIEW_TIME;
        }
        return REVIEW_TIME;
    }

    return (
        (<Card className="add-review-form" variant={outlined ? "outlined" : undefined}>
            <Formik
                innerRef={bagRef}
                enableReinitialize
                initialValues={{
                    additionalReviewers: (review && review.additionalReviewers) || "",
                    comment: (review && review.comment) || "",
                    instruction: (review && review.instruction) || "",
                    privateNote: (review && review.privateNote) || "",
                    reviewStatusType: review && review.reviewStatusType,
                    tagIds: defaultTagIds || [],
                    reviewMinutes: (review && review.reviewMinutes) || null,
                    instructionPreset: null,
                    viewers: review?.viewers || []
                }}
                validate={() => {
                    onChange();
                    const errors = {};
                    return errors;
                }}
                onSubmit={handleSubmit}
            >
                {({ resetForm }) => {
                    return (
                        (<Form>
                            <ConfirmDialog
                                open={openDialog}
                                message="Are you sure?"
                                onCancel={handleCloseClearConfirm}
                                onConfirm={() => handleConfirmClear(resetForm)}
                            />
                            <Grid2 container spacing={2} columnSpacing={6} size={12}>
                                <Grid2 container size={12}>
                                    <Grid2 size={6}>
                                        <Typography variant={"subtitle2"} className={"headerForm"}>
                                            Status
                                        </Typography>

                                        <Field name="reviewStatusType">
                                            {({ field, form: { setFieldValue } }) => {
                                                // eslint-disable-next-line no-unused-vars
                                                const { onChange, ...restField } = field;
                                                return (
                                                    <ReviewStatusTypesSelect
                                                        defaultValue={field.value}
                                                        onChange={(option) => setFieldValue("reviewStatusType", option)}
                                                        selectProps={{ ...restField }}
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </Grid2>
                                    <Grid2
                                        size={{
                                            xs: 6
                                        }}>
                                        <Typography variant={"subtitle2"} className={"headerForm"}>
                                            Viewers
                                        </Typography>

                                        <Field name="viewers">
                                            {({ field, form: { setFieldValue } }) => {
                                                // eslint-disable-next-line no-unused-vars
                                                const { onChange, ...restField } = field;

                                                return (
                                                    <UserSelect defaultValue={field.value}
                                                        placeholder={"Select viewers"}
                                                        multiple
                                                        selectProps={{ ...restField }}
                                                        onChange={(option) => setFieldValue("viewers", option)}
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container size={12}>
                                    <Grid2 container size={6}>
                                        <Grid2 size={4}>
                                            <div style={{ width: 100, height: 20 }} />
                                            <Typography variant={"subtitle2"} className={"headerForm"}>
                                                Instructions
                                            </Typography>
                                        </Grid2>
                                        <Grid2 size={8}>
                                            <Field name="instructionPreset">
                                                {({ field, form: { setFieldValue } }) => {
                                                    return (
                                                        <Autocomplete
                                                            getOptionLabel={(option) => option.label}
                                                            options={instructionPresetOptions}
                                                            disableCloseOnSelect
                                                            onChange={(e, option) => {
                                                                setFieldValue("instructionPreset", option);
                                                                if (option)
                                                                    instructionRef.current.setValue(option.value);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label={
                                                                        field.value ? null : "Select instruction preset"
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    );
                                                }}
                                            </Field>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 size={6}>
                                        <div style={{ width: 100, height: 20 }} />
                                        <Typography variant={"subtitle2"} className={"headerForm"}>
                                            Private Notes
                                        </Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 size={6}>
                                    <Field name="instruction">
                                        {({ field }) => (
                                            <TextAreaEditor
                                                ref={instructionRef}
                                                rootStyle={{ paddingBottom: 10, marginTop: 5 }}
                                                defaultValue={field.value}
                                                reportChange={onChange}
                                            />
                                        )}
                                    </Field>
                                </Grid2>
                                <Grid2 size={6}>
                                    <Field name="privateNote">
                                        {({ field }) => (
                                            <TextAreaEditor
                                                ref={privateNoteRef}
                                                rootStyle={{ paddingBottom: 10, marginTop: 5 }}
                                                defaultValue={field.value}
                                                reportChange={onChange}
                                            />
                                        )}
                                    </Field>
                                </Grid2>
                                <Grid2 container size={12}>
                                    <Grid2 size={6}>
                                        <Typography variant={"subtitle2"} className={"headerForm"}>
                                            Review Tags
                                        </Typography>
                                        <Field name="tagIds">
                                            {({ field, form: { setFieldValue } }) => {
                                                // eslint-disable-next-line no-unused-vars
                                                const { onChange, ...restField } = field;

                                                return (
                                                    <TagSelect
                                                        defaultValue={field.value}
                                                        onChange={(option) => setFieldValue("tagIds", option)}
                                                        {...restField}
                                                        placeholder="Select tags"
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </Grid2>
                                    <Grid2 size={6}>
                                        <Typography
                                            variant={"subtitle2"}
                                            className={"headerForm"}
                                        >
                                            Review Time
                                        </Typography>
                                        <Grid2 paddingTop={3} marginTop={1}>
                                            <Field name="reviewMinutes">
                                                {({ field, form: { setFieldValue } }) => {
                                                    return (
                                                        <>
                                                        <CreatableSelect
                                                            options={reviewTimeOptions()}
                                                            onChange={(e) =>
                                                                handleReviewTimeChange(e.value, setFieldValue)
                                                            }
                                                            value={field.value && {label: field.value.toString(), value: field.value}}
                                                            onKeyDown={(e)=> e.preventDefault}
                                                            placeholder="Select or type review time (minutes)"
                                                            formatCreateLabel={(e) => e}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                  ...theme.colors,
                                                                  primary25: "#e0f2f1",
                                                                  primary: "#009688",
                                                                },
                                                              })}
                                                              hideSelectedOptions
                                                        />
                                                       {invalidReviewTime && <span style={{color: "red", marginTop: 2}}>* Only numbers allowed.</span>}
                                                        </>
                                                    );
                                                }}
                                            </Field>
                                        </Grid2>

                                    </Grid2>
                                </Grid2>

                                <Grid2 style={{ justifyContent: "flex-end" }} size={12}>
                                    <Button
                                        variant={"outlined"}
                                        size={"small"}
                                        color={"primary"}
                                        type="button"
                                        style={{ marginTop: 6, marginRight: 8 }}
                                        onClick={() => setOpenDialog(true)}
                                    >
                                        Clear
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>)
                    );
                }}
            </Formik>
        </Card>)
    );
});

const mapStateToProps = ({ globalApp }) => ({
    tags: globalApp.tags,
    instructionPreset: globalApp.instructionPreset,
});

const mapDispatchToProps = (dispatch) => ({
    changeForm: (payload) => dispatch(actions.CHANGE_FORM.send(payload)),
    getInstructionPreset: (url) => dispatch(globalAppActions.GET_INSTRUCTION_PRESET.send(url)),
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AddReviewForm);
